/* eslint-disable react/no-array-index-key */
import FulfilledTitle from '@assets/fulfilled-title.svg';
import UnfulfilledTitle from '@assets/unfulfilled-title.svg';
import {
  PageTitle,
  BottomButtons,
  Panel, RadioItem, PackageRadioGroup,
} from '@components';
import { usePackageCheckbox } from './hooks';
import { ReasonDialog } from './reason-dialog';

import classes from '../choose/index.module.css';

export const RadioRA = () => {
  const {
    fulfilledItems,
    unFulfilledItems,
    isContinueBtnDisable,
    selectedItems,
    open, reason, reasonList,
    onClickContinue,
    handleChange,
    clearItems,
    handleClose,
    handleOK,
    dialogReasonChange,
    commentsChange,
    handleItemEdit,
  } = usePackageCheckbox();
  const TextConfig = {
    Title: 'Protected item(s)',
    SubTitle: "Please choose which product you'd like to file an Extended Warranty claim for?",
  };

  const getFulfilledBlock = () => {
    if (!fulfilledItems?.length) {
      return null;
    }

    return (
      <Panel icon={FulfilledTitle} title="Fulfilled" className={classes.ful_panel}>
        {
          fulfilledItems.map((packageItem, packageIndex) => (
            <PackageRadioGroup
              key={packageItem.fulfillmentId + packageIndex}
              packageItem={packageItem}
              packageIndex={packageIndex}
              selectedItems={selectedItems}
              onChange={handleChange}
              handleItemEdit={handleItemEdit}
              reasonList={reasonList}
              undeliveredAbled={false}
            />
          ))
        }
      </Panel>
    );
  };

  const getUnfulfilledBlock = () => {
    if (!unFulfilledItems?.length) {
      return null;
    }
    return (
      <Panel icon={UnfulfilledTitle} title="Unfulfilled" className={classes.unful_panel}>
        {unFulfilledItems.map((item, index) => (
          <RadioItem
            // eslint-disable-next-line react/no-array-index-key
            key={item.lineItemId + index}
            item={item}
            index={index}
            disabled
          />
        ))}
      </Panel>
    );
  };

  return (
    <section className={classes.content}>
      <PageTitle title={TextConfig.Title} subTitle={TextConfig.SubTitle} />
      {getFulfilledBlock()}
      {getUnfulfilledBlock()}
      <BottomButtons
        onClickBack={clearItems}
        isContinueDisabled={isContinueBtnDisable}
        onClickContinue={onClickContinue}
      />
      {open && (
        <ReasonDialog
          open={open}
          reason={reason}
          handleClose={handleClose}
          handleOK={handleOK}
          onRadioChange={dialogReasonChange}
          onCommentsChange={commentsChange}
          reasonList={reasonList}
        />
      )}
    </section>
  );
};
